// import thumbnail_1 from '../../assets/images/no-image.jpg'
// import thumbnail_2 from '../../assets/images/no-image.jpg'
// import thumbnail_3 from '../../assets/images/no-image.jpg'
import thumbnail_4 from '../../assets/MantharApp/thumbnail.png'

import image0 from '../MantharApp/0.webp'
import image1 from '../MantharApp/1.webp'
import image2 from '../MantharApp/2.webp'
import image3 from '../MantharApp/3.webp'
import image4 from '../MantharApp/4.webp'
import image5 from '../MantharApp/5.webp'
import image6 from '../MantharApp/6.webp'

export const MantharApp = {
  id:4,
  type:'mobile',
  thumbnails: [thumbnail_4],
  screens: [image0, image1, image2, image3, image4, image5, image6],
 title: 'Manthar – Your Ultimate Companion for Hassle-Free Online Bus Ticket Booking Across Pakistan',
  intro:
    "Say goodbye to long queues and manual ticketing — the Manthar App brings convenient, reliable, and fast bus ticket booking to your fingertips. Designed for users who travel frequently across Pakistan, the app enables passengers to search, book, and manage bus journeys anytime, anywhere. Let's dive into the design and features that make Manthar your ultimate travel companion.",
  features: [
    {
      title: "User-Friendly and Intuitive UI",
      description:
        "The app's clean and minimal design ensures a seamless user experience. Easy navigation, bold CTAs, and real-time responsiveness make booking a ticket as simple as a few taps."
    },
    {
      title: "Real-Time Bus Schedules and Availability",
      description:
        "Check live bus schedules, routes, seat availability, and departure times. Users can quickly compare buses based on time, price, and class (economy, business, sleeper)."
    },
    {
      title: "Secure Online Payments",
      description:
        "Integrated with multiple payment gateways, Manthar ensures safe and quick online payments through debit/credit cards, mobile wallets, and banking apps."
    },
    {
      title: "Interactive Seat Selection",
      description:
        "View bus seat layouts and pick your preferred seat with a tap. The visual seat map is updated in real-time to reflect booked and available seats."
    },
    {
      title: "E-Ticketing & QR Code Boarding",
      description:
        "Once booked, tickets are instantly generated and stored in the app. Use your e-ticket or scan a QR code at boarding for a paperless, smooth travel experience."
    },
    {
      title: "Trip History and Booking Management",
      description:
        "Easily view past trips, cancel bookings, or reschedule journeys. The app helps travelers keep track of all their travel plans in one place."
    },
    {
      title: "Push Notifications and Travel Alerts",
      description:
        "Stay informed with live updates on bus delays, boarding reminders, and promotional offers through real-time notifications."
    }
  ],
  conclusion:
    "The Manthar App simplifies bus travel with a reliable, user-first approach to online booking. Whether you're planning a weekend getaway or daily commute, Manthar ensures your journey begins smoothly — right from your mobile device. Download today and experience the future of intercity travel!"
};
